import { SignedIn, SignedOut } from '@clerk/clerk-react';
import { Link, Navigate, Route, Routes } from 'react-router-dom';

import Auction from './routes/Auction';
import AuctionTags from './routes/AuctionTags';
import Commish from './routes/Commish';
import Contracts from './routes/Contracts';
import Franchises from './routes/Franchises';
import HistoryFranchise from './routes/HistoryFranchise';
import HistoryIndex from './routes/HistoryIndex';
import HistorySeason from './routes/HistorySeason';
import Home from './routes/Home';
import Lineup from './routes/Lineup';
import LiveScoring from './routes/LiveScoring';
import MyFranchise from './routes/MyFranchise';
import Rankings from './routes/Rankings';
import Schedule from './routes/Schedule';
import Standings from './routes/Standings';
import Trades from './routes/Trades';
import Waivers from './routes/Waivers';

export default function App() {
  return (
    <>
      <nav className="border-b bg-gray-50 px-6 py-3 text-sm">
        <Link className="mr-4 font-semibold" to="/">
          BDL
        </Link>
        <Link className="mr-4" to="/franchises">
          Franchises
        </Link>
        <Link className="mr-4" to="/my-franchise">
          My franchise
        </Link>
        <Link className="mr-4" to="/lineup">
          Lineup
        </Link>
        <Link className="mr-4" to="/waivers">
          Waivers
        </Link>
        <Link className="mr-4" to="/auction">
          Auction
        </Link>
        <Link className="mr-4" to="/contracts">
          Contracts
        </Link>
        <Link className="mr-4" to="/trades">
          Trades
        </Link>
        <Link className="mr-4" to="/live-scoring">
          Live scoring
        </Link>
        <Link className="mr-4" to="/standings">
          Standings
        </Link>
        <Link className="mr-4" to="/rankings">
          Rankings
        </Link>
        <Link className="mr-4" to="/schedule">
          Schedule
        </Link>
        <Link className="mr-4" to="/history">
          History
        </Link>
        <Link to="/commish">Commish</Link>
      </nav>
      <SignedIn>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/franchises" element={<Franchises />} />
          <Route path="/my-franchise" element={<MyFranchise />} />
          <Route path="/lineup" element={<Lineup />} />
          <Route path="/waivers" element={<Waivers />} />
          <Route path="/auction" element={<Auction />} />
          <Route path="/auction/tags" element={<AuctionTags />} />
          <Route path="/contracts" element={<Contracts />} />
          <Route path="/trades" element={<Trades />} />
          <Route path="/commish" element={<Commish />} />
          <Route path="/live-scoring" element={<LiveScoring />} />
          <Route path="/standings" element={<Standings />} />
          <Route path="/rankings" element={<Rankings />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/history" element={<HistoryIndex />} />
          <Route path="/history/:year" element={<HistorySeason />} />
          <Route path="/history/franchises/:franchiseId" element={<HistoryFranchise />} />
        </Routes>
      </SignedIn>
      <SignedOut>
        {/* Every authed route needs Convex queries that throw UNAUTHENTICATED
            without an identity — send signed-out visitors to the sign-in
            prompt on Home instead of a blank crashed page. */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </SignedOut>
    </>
  );
}
